<template>
  <div class="mapping-item">
    <p>{{variableItem.id}}</p>
    <p>
      {{variableItem.name}}
      <span
        class="text-disabled"
        v-show="variableItem.isReferenceName == true || variableItem.isId == true"
      >
        <span
          v-show="variableItem.isId == true"
        >{{variableItem.isReferenceName == true ? 'ID & ' : 'ID'}}</span>
        <span style="margin-left:4px;" v-show="variableItem.isReferenceName == true">{{$t('variable-mapping.reference-name')}}</span>
        <i class="fa-light fa-check-circle text-success"></i>
      </span>
    </p>
    <p class="example-data">{{variableItem.exampleData || ''}}</p>
    <select v-model="variableItem.type" class="type-selector">
      <option value="Text">{{$t('variable-mapping.text')}}</option>
      <option value="Number">{{$t('variable-mapping.number')}}</option>
      <option value="Date">{{$t('variable-mapping.date')}}</option>
      <option value="List">{{$t('variable-mapping.list')}}</option>
      <option value="Bool">{{$t('variable-mapping.bool')}}</option>
    </select>
  </div>
</template>
<script>
export default {
  data() {
    return {
      variableItem: this.variable
    };
  },
  props: {
    variable: Object
  }
};
</script>
<style lang="less">
.mapping-item {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 150px;
  padding: 12px 6px;
  gap: 12px;
  border-radius: var(--standard-border-radius);
  &:hover {
    background-color: var(--hover-white);
  }
  p {
    align-self: center;
    margin: 0;
    &:first-of-type {
      padding-left: 6px;
    }
  }
  .type-selector {
    cursor: pointer;
    background-color: transparent;
    padding: 4px 0;
    border: none;
    border-bottom: 1px solid var(--charcoal-50);
  }
  .example-data {
    color: var(--charcoal-50);
  }
  .text-success{
    margin-left: 4px;
    margin-top: 2px;
  }
  .text-disabled{
    display: inline-flex;
    align-items: center;
  }
}
</style>